/** @format */

import {MegaMenuLabels} from 'frontier/ds/quoter/header/megamenu_labels';
import {MegaMenuCartons} from 'frontier/ds/quoter/header/megamenu_cartons';
import {MegaMenuAbout} from 'frontier/ds/quoter/header/megamenu_about';
import {MegaMenuGraphics} from 'frontier/ds/quoter/header/megamenu_graphics';

import React, {useState} from 'react';
import {
    MOBILE_SECTION_ABOUT,
    MOBILE_SECTION_CARTONS,
    MOBILE_SECTION_GRAPHICS,
    MOBILE_SECTION_LABELS
} from 'frontier/ds/quoter/header/header';

export const MobileMenu = ({
    setCurrentOpenMegaMenuMobile,
    currentOpenMegaMenuMobile,
    isShowingMobile
}) => {
    const MobileGoBackButton = () => (
        <div
            className="header-23cr_megamenu--mobile_go-back"
            onClick={() => setCurrentOpenMegaMenuMobile(0)}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
                    fill="#26313a"></path>
            </svg>
            <h6>BACK</h6>
        </div>
    );

    const MobileOpenMegaMenuArrow = ({section, label}) => (
        <>
            <svg
                onClick={() => setCurrentOpenMegaMenuMobile(section)}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
                    fill="#26313a"></path>
            </svg>
            <h6 onClick={() => setCurrentOpenMegaMenuMobile(section)}>{label}</h6>
        </>
    );

    return (
        <div
            className={`header-23cr_megamenu--mobile ${
                isShowingMobile
                    ? 'header-23cr_megamenu--mobile--open'
                    : 'header-23cr_megamenu--mobile--close'
            }`}>
            <div className="megamenu--mobile-23cr_container">
                <ul className="mobile-container-23rc_links-list">
                    {/* Icon options*/}
                    <li>
                        <div className="links-list-23cr--mobile_link-icons">
                            <div>
                                <a
                                    href="tel:8772774682"
                                    className="links-list-23cr--mobile_link links-list-23cr--mobile_link-phone">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1131_372)">
                                            <path
                                                d="M4.82667 10.3867C6.74667 14.16 9.84 17.2533 13.6133 19.1733L16.5467 16.24C16.92 15.8667 17.44 15.76 17.9067 15.9067C19.4 16.4 21 16.6667 22.6667 16.6667C23.0203 16.6667 23.3594 16.8071 23.6095 17.0572C23.8595 17.3072 24 17.6464 24 18V22.6667C24 23.0203 23.8595 23.3594 23.6095 23.6095C23.3594 23.8595 23.0203 24 22.6667 24C16.6551 24 10.8897 21.6119 6.63891 17.3611C2.38809 13.1103 0 7.34491 0 1.33333C0 0.979711 0.140476 0.640573 0.390524 0.390524C0.640573 0.140476 0.979711 0 1.33333 0H6C6.35362 0 6.69276 0.140476 6.94281 0.390524C7.19286 0.640573 7.33333 0.979711 7.33333 1.33333C7.33333 3 7.6 4.6 8.09333 6.09333C8.24 6.56 8.13333 7.08 7.76 7.45333L4.82667 10.3867Z"
                                                fill="#26313a"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1131_372">
                                                <rect width="24" height="24" fill="#26313a"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                                <a
                                    href="/account/users/login"
                                    className="links-list-23cr--mobile_link links-list-23cr--mobile_link-account">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1130_373)">
                                            <path
                                                d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 3.6C13.992 3.6 15.6 5.208 15.6 7.2C15.6 9.192 13.992 10.8 12 10.8C10.008 10.8 8.4 9.192 8.4 7.2C8.4 5.208 10.008 3.6 12 3.6ZM12 20.64C9 20.64 6.348 19.104 4.8 16.776C4.836 14.388 9.6 13.08 12 13.08C14.388 13.08 19.164 14.388 19.2 16.776C17.652 19.104 15 20.64 12 20.64Z"
                                                fill="#26313a"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1130_373">
                                                <rect width="24" height="24" fill="#26313a"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                                <a
                                    href="/cart"
                                    className="links-list-23cr--mobile_link links-list-23cr--mobile_link-cart">
                                    <span className="has-badge">
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M7.2 19.2C5.88 19.2 4.812 20.28 4.812 21.6C4.812 22.92 5.88 24 7.2 24C8.52 24 9.6 22.92 9.6 21.6C9.6 20.28 8.52 19.2 7.2 19.2ZM0 0V2.4H2.4L6.72 11.508L5.1 14.448C4.908 14.784 4.8 15.18 4.8 15.6C4.8 16.92 5.88 18 7.2 18H21.6V15.6H7.704C7.536 15.6 7.404 15.468 7.404 15.3L7.44 15.156L8.52 13.2H17.46C18.36 13.2 19.152 12.708 19.56 11.964L23.856 4.176C23.952 4.008 24 3.804 24 3.6C24 2.94 23.46 2.4 22.8 2.4H5.052L3.924 0H0ZM19.2 19.2C17.88 19.2 16.812 20.28 16.812 21.6C16.812 22.92 17.88 24 19.2 24C20.52 24 21.6 22.92 21.6 21.6C21.6 20.28 20.52 19.2 19.2 19.2Z"
                                                fill="#26313a"></path>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                            <a
                                className="links-list-23cr--mobile_order_now"
                                href="/orders/custom-labels">
                                <h6>Order Now</h6>
                            </a>
                        </div>
                    </li>
                    <li>
                        <div
                            className="links-list-23cr--mobile_order-expandable-button order-expandable-button-23cr_labels"
                            role="button"
                            aria-label="Click me to perform an action">
                            {currentOpenMegaMenuMobile !== MOBILE_SECTION_LABELS && (
                                <MobileOpenMegaMenuArrow
                                    section={MOBILE_SECTION_LABELS}
                                    label={'Labels'}
                                />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_LABELS && (
                                <MobileGoBackButton />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_LABELS && (
                                <div className="links-list-23cr--mobile_megamenu-holder links-list-23cr--mobile_megamenu-holder--labels">
                                    <MegaMenuLabels
                                        onMouseOver={null}
                                        display={'block'}
                                        isMobile={true}
                                    />
                                </div>
                            )}
                        </div>
                    </li>
                    <li>
                        <div
                            className="links-list-23cr--mobile_order-expandable-button order-expandable-button-23cr_cartons"
                            role="button"
                            aria-label="Click me to perform an action">
                            {currentOpenMegaMenuMobile !== MOBILE_SECTION_CARTONS && (
                                <MobileOpenMegaMenuArrow
                                    section={MOBILE_SECTION_CARTONS}
                                    label={'Cartons'}
                                />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_CARTONS && (
                                <MobileGoBackButton />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_CARTONS && (
                                <div className="links-list-23cr--mobile_megamenu-holder links-list-23cr--mobile_megamenu-holder--cartons">
                                    <MegaMenuCartons
                                        onMouseOver={null}
                                        display={'block'}
                                        isMobile={true}
                                    />
                                </div>
                            )}
                        </div>
                    </li>
                    <li>
                        <div
                            className="links-list-23cr--mobile_order-expandable-button order-expandable-button-23cr_graphics"
                            role="button"
                            aria-label="Click me to perform an action">
                            {currentOpenMegaMenuMobile !== MOBILE_SECTION_GRAPHICS && (
                                <MobileOpenMegaMenuArrow
                                    section={MOBILE_SECTION_GRAPHICS}
                                    label={'Graphic Design'}
                                />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_GRAPHICS && (
                                <MobileGoBackButton />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_GRAPHICS && (
                                <div className="links-list-23cr--mobile_megamenu-holder links-list-23cr--mobile_megamenu-holder--graphics">
                                    <MegaMenuGraphics
                                        onMouseOver={null}
                                        display={'block'}
                                        isMobile={true}
                                    />
                                </div>
                            )}
                        </div>
                    </li>
                    <li>
                        <div
                            className="links-list-23cr--mobile_order-expandable-button order-expandable-button-23cr_about"
                            role="button"
                            aria-label="Click me to perform an action">
                            {currentOpenMegaMenuMobile !== MOBILE_SECTION_ABOUT && (
                                <MobileOpenMegaMenuArrow
                                    section={MOBILE_SECTION_ABOUT}
                                    label={'About'}
                                />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_ABOUT && (
                                <MobileGoBackButton />
                            )}

                            {currentOpenMegaMenuMobile === MOBILE_SECTION_ABOUT && (
                                <div className="links-list-23cr--mobile_megamenu-holder links-list-23cr--mobile_megamenu-holder--about">
                                    <MegaMenuAbout
                                        onMouseOver={null}
                                        display={'block'}
                                        isMobile={true}
                                    />
                                </div>
                            )}
                        </div>
                    </li>
                    <li>
                        <a
                            href="/marketplace"
                            className="links-list-23cr--mobile_order-expandable-button">
                            <h6 className="mobile-section-button m-0 p-0">Marketplace</h6>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};
